import React from "react";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { ALL_IN, IMAGES } from "../mock";
import Reveal from "./ui/Reveal";

export default function AllInExperience({ onOpenCheckout }) {
  return (
    <section id="all-in" className="py-24 lg:py-36 relative bg-[#0c0c0c]">
      <div className="container-max">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <span className="section-label">Il percorso completo</span>
            <div className="mt-6 inline-flex items-center gap-2 border border-white/10 rounded-full px-4 py-1.5 text-white/70 text-xs tracking-widest uppercase">
              <Sparkles size={12} className="text-lime" /> {ALL_IN.code}
            </div>
            <Reveal variant="zoom" as="h2" className="font-display text-4xl lg:text-6xl leading-[1] text-white mt-8">
              {ALL_IN.title}
            </Reveal>
            <p className="text-white/70 text-lg mt-8 max-w-xl">
              <span className="text-white font-medium">{ALL_IN.hours}</span>
            </p>
            <p className="text-white/60 text-base mt-2">5 corsi strutturati con il Metodo My Digital Action.</p>

            <div className="mt-10">
              <div className="font-mono-label text-[11px] text-white/50 mb-4">Formula flessibile</div>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {ALL_IN.formats.map((f, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 text-white/85 text-sm lg:text-base border border-white/10 rounded-xl p-4 bg-card hover-lift"
                  >
                    <span className="font-display" style={{ color: "#6b8bff" }}>0{i + 1}</span>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-10 flex flex-wrap gap-4">
              <a href="#prezzo" className="btn-primary">
                Vai all’offerta Early Bird <ArrowUpRight size={18} />
              </a>
              <a href="#corsi" className="btn-secondary">
                Vedi i 5 corsi
              </a>
            </div>
          </div>

          <Reveal variant="fade-right" delay={150} className="lg:col-span-5">
            <div className="relative rounded-2xl overflow-hidden border border-white/10 aspect-[4/5]">
              <img src={IMAGES.training} alt="All-in Experience" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8">
                <div className="font-mono-label text-[10px] text-white/60">01 — 05</div>
                <div className="font-display text-2xl lg:text-3xl text-white mt-2">Un unico percorso.<br />Cinque moduli.</div>
                <div className="text-white/60 text-sm mt-3">Prendi il controllo della tua comunicazione digitale.</div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
